import { useContext, useEffect, useState } from "react";
import { Check, Star } from "lucide-react";
import "../styles/WhySquaay.css";
import { ThemeContext } from "../../../../context/ThemeContext";
import { listOpenVendors } from "../../../../common/services/vendors";
import { OpenVendor } from "../../../../common/services/vendors.types";
import { BASE_URL } from "../../../../common/config/config";

const points = [
  "Save your go-to combo once, reorder in under 5 seconds",
  "Smart AI ordering remembers exactly what you love",
  "Earn cashback the more items you order",
  "Discover new restaurants and vendors near you",
];

const placeholderImage =
  "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=1160&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

const WhySquaay = () => {
  const { theme } = useContext(ThemeContext);
  const [vendors, setVendors] = useState<OpenVendor[]>([]);
  const [vendorsLoading, setVendorsLoading] = useState(true);

  useEffect(() => {
    listOpenVendors({ limit: 6 })
      .then(setVendors)
      .catch((error) => {
        console.error(`GET ${BASE_URL}/v2/vendors/open failed:`, error);
        setVendors([]);
      })
      .finally(() => setVendorsLoading(false));
  }, []);

  return (
    <section id="call-to-action" className="why-squaay-section">
      <div className="why-squaay-wrapper">
        <div className="why-squaay-intro">
          <div className="why-squaay-text">
            <span className="section-label">Why Squaay</span>
            <h2 className="why-squaay-title">
              Everything you need to eat well, fast
            </h2>
            <p className="why-squaay-subtitle">
              Squaay is built around one idea: ordering food you already
              know you love shouldn't take ten minutes every time.
            </p>

            <ul className="why-squaay-points">
              {points.map((point) => (
                <li key={point}>
                  <Check size={18} />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="why-squaay-visual">
            <div className="why-squaay-phone-frame">
              {theme === "dark" ? (
                <img src="/assets/VirtualKitchenDark.png" alt="Squaay App" />
              ) : (
                <img src="/assets/VirtualKitchenLight.png" alt="Squaay App" />
              )}
            </div>
          </div>
        </div>

        {(vendorsLoading || vendors.length > 0) && (
          <div className="trending-restaurants">
            <div className="trending-header">
              <span className="section-label">Explore</span>
              <h2 className="trending-title">Vendors on Squaay</h2>
            </div>

            <div className="restaurant-cards-grid">
              {vendorsLoading &&
                Array.from({ length: 6 }).map((_, index) => (
                  <div className="restaurant-card is-loading" key={index}>
                    <div className="restaurant-card-image" />
                    <div className="restaurant-card-body">
                      <p className="restaurant-name skeleton-line" />
                      <p className="restaurant-cuisine skeleton-line" />
                    </div>
                  </div>
                ))}

              {vendors.map((vendor) => (
                <a
                  className="restaurant-card"
                  key={vendor.id}
                  href={vendor.username ? `/${vendor.username}` : "/download"}
                >
                  <div className="restaurant-card-image">
                    <img
                      src={vendor.imageUrl || placeholderImage}
                      alt={vendor.businessName}
                    />
                  </div>
                  <div className="restaurant-card-body">
                    <p className="restaurant-name">{vendor.businessName}</p>
                    <p className="restaurant-cuisine">
                      {vendor.address || "Lagos, Nigeria"}
                    </p>
                    <div className="restaurant-meta">
                      {vendor.reviews > 0 ? (
                        <span className="restaurant-rating">
                          <Star size={14} fill="currentColor" />
                          {vendor.rating}
                        </span>
                      ) : (
                        <span className="restaurant-rating">New</span>
                      )}
                      <span className="restaurant-time">
                        {vendor.reviews > 0
                          ? `${vendor.reviews} review${vendor.reviews === 1 ? "" : "s"}`
                          : "Just joined"}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default WhySquaay;
